var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDischargingDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{clip-path:url(#SVGID_00000080165718397427844410000007184058822436241855_);fill:url(#SVGID_00000028302778370718640580000002871066788369680260_);}\r\n\t.st1{fill:url(#SVGID_00000140696258676874405410000001553558662217239996_);}\r\n\t.st2{fill:url(#SVGID_00000013913983633852685520000001474716023193768601_);}\r\n\t.st3{fill:url(#SVGID_00000080911748319181753670000011925654560050009231_);}\r\n\t.st4{fill:url(#SVGID_00000155137522931111435460000015537783097062262689_);}\r\n\t.st5{fill:url(#SVGID_00000132081252436106841940000012279603039680827015_);}\r\n\t.st6{fill:url(#SVGID_00000133499351394722989210000008114421956621014153_);}\r\n\t.st7{fill:url(#SVGID_00000157268174123229921410000007967807342169805470_);}\r\n\t.st8{fill:url(#SVGID_00000178914374847806136340000013698301926507068589_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044878426829494232460000005105029171109534640_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.8617,
    y1: 32.0213,
    x2: 20.8617,
    y2: 2.9787,
    gradientTransform: "matrix(-1 0 0 -1 38.3617 35)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1A029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB760B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044878426829494232460000005105029171109534640_)"
    },
    d: "M22.5,3C22.9,3.1,23,3.4,23,3.8 c0,4.8,0,9.7,0,14.5c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0c2,0,4,0,6.1,0c0.1,0,0.3,0,0.4,0c0.4,0.1,0.6,0.5,0.3,0.9 c-0.1,0.1-0.2,0.2-0.2,0.3c-3.9,3.9-7.8,7.8-11.8,11.8c-0.5,0.5-0.7,0.5-1.2,0C13,27.8,9.1,23.8,5.1,19.9c-0.1-0.1-0.2-0.2-0.2-0.3 c-0.2-0.3-0.1-0.8,0.3-0.9c0.1,0,0.3,0,0.4,0c2,0,4,0,6.1,0c0.1,0,0.2,0,0.4,0c0-0.1,0-0.3,0-0.4c0-4.8,0-9.7,0-14.5 c0-0.4,0.1-0.7,0.4-0.9C15.8,3,19.2,3,22.5,3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargingDown);
export default __webpack_public_path__ + "static/media/discharging_down.18bff63acbf90f61096cb5aeeec04a61.svg";
export { ForwardRef as ReactComponent };